import {search, SearchResult} from "@/api/SearchApi.ts";
import SearchResultEntry from "@/search/SearchResultEntry.tsx";
import SearchPopover from "@/search/SearchPopover.tsx";

export default function SearchView() {
    return <SearchPopover<SearchResult>
        className="w-60 lg:w-104"
        contentClassName="w-[min(26rem,calc(100vw-1rem))]"
        search={(query, signal) => search(query, {size: 15}, signal)}
        getKey={result => `${result.type}-${result.id}`}
        onSelect={() => undefined}
        renderItem={({item, query, select, selecting}) => (
            <SearchResultEntry result={item} query={query} onSelect={select} selecting={selecting}/>
        )}
    />;
}
